import IAgendaWelcomeRepository from 'modules/customer/domain/repositories/IAgendaWelcomeRepository';
import IHTTPProvider from 'shared/domain/providers/IHTTPProvider';

type TAgendaWelcomeResponse = {
  nome: string;
  quantidadeApurada: number;
  quantidadeAgendamentosAnalisados: number;
  limiteAceito: number;
};

export default class VectisAgendaWelcomeRepository
  implements IAgendaWelcomeRepository
{
  constructor(private httpProvider: IHTTPProvider) {}

  public findOne: IAgendaWelcomeRepository['findOne'] = async ({
    customerId,
    unitId,
    flowType,
  }) => {
    const response = await this.httpProvider.get<TAgendaWelcomeResponse>(
      `/caf/onboarding/${customerId}/boas-vindas`,
      {
        params: {
          idUnidade: unitId,
          tipoFluxo: flowType,
        },
      },
    );

    if (!response || typeof response !== 'object' || !response.nome) {
      throw new Error('Resposta inválida ao buscar dados de boas-vindas');
    }

    return {
      name: response.nome,
      count: response.quantidadeApurada,
      analyzed: response.quantidadeAgendamentosAnalisados,
      limit: response.limiteAceito,
    };
  };
}
